import isEmpty from 'lodash/fp/isEmpty';

import type { BulletinBoard } from '@autopass-web/types';

import { PromotionItem } from '#/guest-aps/components/promotion-item';
import { ApsPartnerPromotion } from '#/guest-aps/features/search-plate-number/aps-patner-promotion-item';

interface CreateCarouselPromotionListProps {
  apsPartnerTemplate?: BulletinBoard;
  promotions: BulletinBoard[];
}

export const createCarouselPromotionList = (
  { apsPartnerTemplate, promotions }: CreateCarouselPromotionListProps,
  options?: { onClickFactory: (bulletin: BulletinBoard) => () => void },
) => {
  const { onClickFactory } = options ?? {};
  if (apsPartnerTemplate) {
    const {
      display_promotion,
      promotion_background_color,
      promotion_font_color,
      promotion_subtitle,
      promotion_title,
      promotion_image,
      promotion_link,
    } = apsPartnerTemplate.attributes;

    if (display_promotion !== 'yes') return [];

    return [
      <ApsPartnerPromotion
        key={apsPartnerTemplate.id}
        link={promotion_link}
        subtitle={promotion_subtitle}
        title={promotion_title}
        image={promotion_image}
        backgroundColor={promotion_background_color}
        fontColor={promotion_font_color}
      />,
    ];
  }

  if (promotions == null || isEmpty(promotions)) return [];

  return promotions.map((promotion) => {
    const { color, background_color, sub_title, image_url, title } =
      promotion.attributes;

    const isOpenLink =
      promotion.action.type === 'open_link' && promotion.action?.open_link?.uri;

    const url = isOpenLink
      ? promotion.action.open_link.uri
      : promotion.attributes.promotion_link;

    return (
      <PromotionItem
        key={promotion.id}
        subTitle={sub_title}
        title={title}
        color={color}
        backgroundColor={background_color}
        imageUrl={image_url}
        promotionId={promotion.id}
        uri={url}
        onClick={onClickFactory?.(promotion)}
      />
    );
  });
};
